/* Online Vitamins Matte theme scripts. No dependencies. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var ROOT = (routes.root || '/').replace(/\/$/, '');
  var desktop = window.matchMedia('(min-width: 990px)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  var ICONS = {
    check: '<svg class="icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.7 2.7L16.5 9.5"/></svg>',
    alert: '<svg class="icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.4v.1"/></svg>',
    close: '<svg class="icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    arrow: '<svg class="icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    truck: '<svg class="icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2.8 6.5h10.7v9.8H2.8z"/><path d="M13.5 9.8h4.1l3.2 3.3v3.2h-7.3"/><circle cx="7" cy="17.6" r="1.9"/><circle cx="17.2" cy="17.6" r="1.9"/></svg>',
    chevronLeft: '<svg class="icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 7l-5 5 5 5"/></svg>',
    chevronRight: '<svg class="icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 7l5 5-5 5"/></svg>'
  };

  function storageGet(store, key) {
    try { return JSON.parse(window[store].getItem(key)); } catch (e) { return null; }
  }
  function storageSet(store, key, value) {
    try { window[store].setItem(key, JSON.stringify(value)); } catch (e) { /* storage unavailable */ }
  }
  function storageRemove(store, key) {
    try { window[store].removeItem(key); } catch (e) { /* storage unavailable */ }
  }

  var RV_KEY = 'ov:recently-viewed';
  var RV_CACHE = 'ov:recently-viewed-cards';
  function rvRead() {
    var list = storageGet('localStorage', RV_KEY);
    return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
  }
  function rvAdd(handle) {
    var list = rvRead().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    storageSet('localStorage', RV_KEY, list.slice(0, 16));
  }
  function rvRemove(handle) {
    storageSet('localStorage', RV_KEY, rvRead().filter(function (h) { return h !== handle; }));
  }
  function rvClear() {
    storageRemove('localStorage', RV_KEY);
    storageRemove('sessionStorage', RV_CACHE);
  }

  /* ---------- Image viewer ---------- */
  var lightbox = (function () {
    var dialog = null;
    var stage, img, counter, prev, next;
    var items = [];
    var index = 0;
    var closingFromHistory = false;

    function largeSrc(src) {
      if (!src) return src;
      if (src.indexOf('//') === 0) src = window.location.protocol + src;
      try {
        var url = new URL(src, window.location.href);
        if (/cdn\.shopify\.com|\/cdn\/shop\//.test(url.href)) {
          url.searchParams.delete('height');
          url.searchParams.delete('crop');
          url.searchParams.set('width', '2400');
        }
        return url.toString();
      } catch (e) {
        return src;
      }
    }

    function setZoom(on, event) {
      stage.classList.toggle('is-zoomed', on);
      if (on && event) {
        var rect = stage.getBoundingClientRect();
        var rx = (event.clientX - rect.left) / rect.width;
        var ry = (event.clientY - rect.top) / rect.height;
        requestAnimationFrame(function () {
          stage.scrollLeft = Math.max(0, img.offsetWidth * rx - rect.width / 2);
          stage.scrollTop = Math.max(0, img.offsetHeight * ry - rect.height / 2);
        });
      }
    }

    function show(i) {
      index = (i + items.length) % items.length;
      setZoom(false);
      img.src = items[index].src;
      img.alt = items[index].alt || '';
      counter.textContent = items.length > 1 ? (index + 1) + ' of ' + items.length : '';
      prev.hidden = next.hidden = items.length < 2;
    }

    function close() {
      if (!dialog) return;
      if (typeof dialog.close === 'function') { dialog.close(); } else { dialog.removeAttribute('open'); onClose(); }
    }

    function onClose() {
      setZoom(false);
      lockScroll(false);
      // Opening the viewer added a history entry; remove it when the viewer is closed with its own controls.
      if (!closingFromHistory && window.history.state && window.history.state.ovLightbox) window.history.back();
      closingFromHistory = false;
    }

    window.addEventListener('popstate', function () {
      if (dialog && dialog.open) {
        closingFromHistory = true;
        close();
      }
    });

    function build() {
      dialog = document.createElement('dialog');
      dialog.className = 'lightbox';
      dialog.setAttribute('aria-label', 'Image viewer');
      dialog.innerHTML =
        '<div class="lightbox__stage"><img class="lightbox__image" alt=""></div>' +
        '<button type="button" class="lightbox__btn lightbox__close" aria-label="Close image viewer">' + ICONS.close + '</button>' +
        '<button type="button" class="lightbox__btn lightbox__prev" aria-label="Previous image">' + ICONS.chevronLeft + '</button>' +
        '<button type="button" class="lightbox__btn lightbox__next" aria-label="Next image">' + ICONS.chevronRight + '</button>' +
        '<p class="lightbox__hint"><span class="lightbox__counter"></span><span>Click or tap the image to zoom</span></p>';
      document.body.appendChild(dialog);
      stage = $('.lightbox__stage', dialog);
      img = $('.lightbox__image', dialog);
      counter = $('.lightbox__counter', dialog);
      prev = $('.lightbox__prev', dialog);
      next = $('.lightbox__next', dialog);
      $('.lightbox__close', dialog).addEventListener('click', close);
      prev.addEventListener('click', function () { show(index - 1); });
      next.addEventListener('click', function () { show(index + 1); });
      img.addEventListener('click', function (event) { setZoom(!stage.classList.contains('is-zoomed'), event); });
      stage.addEventListener('click', function (event) { if (event.target === stage) close(); });
      dialog.addEventListener('close', onClose);
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' && items.length > 1) show(index - 1);
        if (event.key === 'ArrowRight' && items.length > 1) show(index + 1);
      });
    }

    return {
      largeSrc: largeSrc,
      open: function (list, start) {
        if (!list || !list.length) return;
        if (!dialog) build();
        items = list.map(function (item) { return { src: largeSrc(item.src), alt: item.alt }; });
        show(start || 0);
        var wasOpen = dialog.open;
        if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); } else { dialog.setAttribute('open', ''); }
        if (!wasOpen && window.history.pushState) window.history.pushState({ ovLightbox: true }, '');
        lockScroll(true);
        $('.lightbox__close', dialog).focus();
      }
    };
  })();

  /* ---------- Utilities ---------- */
  function $(selector, scope) { return (scope || document).querySelector(selector); }
  function $$(selector, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || theme.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      var parts = (number / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
  }

  /* ---------- Header offset and scroll state ---------- */
  var headerSection = $('.section-header');
  var header = $('[data-header]');

  function setHeaderOffset() {
    if (!headerSection) return;
    var sticky = getComputedStyle(headerSection).position === 'sticky';
    var height = sticky ? headerSection.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--header-offset', Math.round(height) + 'px');
  }
  setHeaderOffset();
  window.addEventListener('resize', debounce(setHeaderOffset, 150));
  window.addEventListener('load', setHeaderOffset);

  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Announcement rotation on small screens ---------- */
  $$('.announcement__list').forEach(function (list) {
    var items = $$('.announcement__item', list);
    if (items.length < 2) return;
    var index = 0;
    var timer = null;
    function show(i) {
      items.forEach(function (item, n) { item.classList.toggle('is-active', n === i); });
    }
    function start() {
      if (timer || desktop.matches) return;
      list.classList.add('is-rotating');
      show(index);
      timer = setInterval(function () {
        index = (index + 1) % items.length;
        show(index);
      }, 4500);
    }
    function stop() {
      clearInterval(timer);
      timer = null;
      list.classList.remove('is-rotating');
    }
    function sync() { if (desktop.matches) { stop(); } else { start(); } }
    if (desktop.addEventListener) desktop.addEventListener('change', sync);
    list.addEventListener('mouseenter', stop);
    list.addEventListener('mouseleave', sync);
    sync();
  });

  /* ---------- Details menus: drawer, dropdowns, search ---------- */
  var drawer = $('[data-drawer]');
  if (drawer) {
    drawer.addEventListener('toggle', function () {
      lockScroll(drawer.open);
      if (drawer.open) {
        var close = $('[data-drawer-close]', drawer);
        if (close) setTimeout(function () { close.focus(); }, 50);
      }
    });
    $$('[data-drawer-close]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.open = false;
        var summary = $('summary', drawer);
        if (summary) summary.focus();
      });
    });
  }

  var dropdowns = $$('[data-dropdown]');
  dropdowns.forEach(function (dropdown) {
    var leaveTimer;
    dropdown.addEventListener('toggle', function () {
      if (!dropdown.open) return;
      dropdowns.forEach(function (other) { if (other !== dropdown) other.open = false; });
    });
    dropdown.addEventListener('mouseenter', function () {
      if (!finePointer.matches || !desktop.matches) return;
      clearTimeout(leaveTimer);
      dropdown.open = true;
    });
    dropdown.addEventListener('mouseleave', function () {
      if (!finePointer.matches || !desktop.matches) return;
      leaveTimer = setTimeout(function () { dropdown.open = false; }, 140);
    });
  });

  var searchPop = $('[data-search]');
  if (searchPop) {
    searchPop.addEventListener('toggle', function () {
      if (searchPop.open) {
        var input = $('input[type="search"]', searchPop);
        if (input) setTimeout(function () { input.focus(); }, 30);
      }
    });
  }

  document.addEventListener('click', function (event) {
    $$('[data-dropdown][open], [data-search][open]').forEach(function (el) {
      if (!el.contains(event.target)) el.open = false;
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = $$('[data-dropdown][open], [data-search][open], [data-drawer][open]');
    open.forEach(function (el) {
      el.open = false;
      var summary = $('summary', el);
      if (summary) summary.focus();
    });
    closeFilters();
    hideNotice();
  });

  /* ---------- Predictive search ---------- */
  $$('[data-predictive]').forEach(function (form) {
    var input = $('[data-predictive-input]', form);
    var results = $('[data-predictive-results]', form);
    if (!input || !results) return;
    var controller = null;
    var activeIndex = -1;
    var lastTerm = '';

    function close() {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
    }

    function options() { return $$('[role="option"]', results); }

    function highlight(index) {
      var opts = options();
      opts.forEach(function (opt, n) { opt.setAttribute('aria-selected', n === index ? 'true' : 'false'); });
      activeIndex = index;
      if (opts[index]) {
        input.setAttribute('aria-activedescendant', opts[index].id);
        opts[index].scrollIntoView({ block: 'nearest' });
      }
    }

    function highlightTerm(text, term) {
      var safe = escapeHtml(text);
      var index = text.toLowerCase().indexOf(term.toLowerCase());
      if (index < 0) return safe;
      return escapeHtml(text.slice(0, index)) + '<mark>' + escapeHtml(text.slice(index, index + term.length)) + '</mark>' + escapeHtml(text.slice(index + term.length));
    }

    // Product results only: mixing in pages and articles pushes the best product matches down the list.
    function searchHref(text) {
      return (routes.search || '/search') + '?q=' + encodeURIComponent(text) + '&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last';
    }

    function render(term, products, queries, collections, articles) {
      var searchUrl = searchHref(term);
      var html = '';
      var n = 0;
      products = (products || []).slice(0, 5);
      queries = (queries || []).filter(function (q) { return q.text && q.text.toLowerCase() !== term.toLowerCase(); }).slice(0, 4);
      collections = (collections || []).slice(0, 4);
      articles = (articles || []).slice(0, 2);
      if (queries.length) {
        html += '<p class="predictive__heading">Suggestions</p><ul class="predictive__chips" role="listbox" aria-label="Search suggestions">';
        queries.forEach(function (q) {
          // The span keeps the space before the highlighted words (the chip is a flex box, which drops it).
          html += '<li><a class="predictive__chip" role="option" aria-selected="false" id="' + input.id + '-opt-' + (n++) + '" href="' + escapeHtml(searchHref(q.text)) + '"><span>' + highlightTerm(q.text, term) + '</span></a></li>';
        });
        html += '</ul>';
      }
      if (collections.length) {
        html += '<p class="predictive__heading">Categories</p><ul class="predictive__chips" role="listbox" aria-label="Categories">';
        collections.forEach(function (c) {
          html += '<li><a class="predictive__chip predictive__chip--category" role="option" aria-selected="false" id="' + input.id + '-opt-' + (n++) + '" href="' + escapeHtml(c.url) + '">' + escapeHtml(c.title) + '</a></li>';
        });
        html += '</ul>';
      }
      if (products.length) {
        html += '<p class="predictive__heading">Products</p><ul class="predictive__list" role="listbox" aria-label="Products">';
        products.forEach(function (p) {
          var image = p.image || (p.featured_image && p.featured_image.url) || '';
          if (image) image += (image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          var price = p.price != null ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
          html += '<li>' +
            '<a class="predictive__item" role="option" aria-selected="false" id="' + input.id + '-opt-' + (n++) + '" href="' + escapeHtml(p.url) + '">' +
            '<span class="predictive__media">' + (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy" width="52" height="52">' : '') + '</span>' +
            '<span>' + (p.vendor ? '<span class="predictive__vendor">' + escapeHtml(p.vendor) + '</span>' : '') +
            '<span class="predictive__title">' + escapeHtml(p.title) + '</span></span>' +
            '<span class="predictive__price">' + escapeHtml(price) + '</span>' +
            '</a></li>';
        });
        html += '</ul>';
      } else if (!queries.length && !collections.length && !articles.length) {
        html += '<p class="predictive__empty">No products match &ldquo;' + escapeHtml(term) + '&rdquo; yet. Try a brand or an ingredient.</p>';
      }
      if (articles.length) {
        html += '<p class="predictive__heading">Articles</p><ul class="predictive__list" role="listbox" aria-label="Articles">';
        articles.forEach(function (a) {
          var image = a.image || (a.featured_image && a.featured_image.url) || '';
          if (image && typeof image === 'object') image = image.url || image.src || '';
          if (image) image += (image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          html += '<li>' +
            '<a class="predictive__item" role="option" aria-selected="false" id="' + input.id + '-opt-' + (n++) + '" href="' + escapeHtml(a.url) + '">' +
            '<span class="predictive__media predictive__media--photo">' + (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy" width="52" height="52">' : '') + '</span>' +
            '<span><span class="predictive__vendor">Article</span><span class="predictive__title">' + escapeHtml(a.title) + '</span></span>' +
            '<span></span>' +
            '</a></li>';
        });
        html += '</ul>';
      }
      html += '<a class="predictive__all" href="' + escapeHtml(searchUrl) + '"><span>See all products for &ldquo;' + escapeHtml(term) + '&rdquo;</span>' + ICONS.arrow + '</a>';
      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    }

    var search = debounce(function () {
      var term = input.value.trim();
      if (term.length < 2) { close(); return; }
      if (term === lastTerm && !results.hidden) return;
      lastTerm = term;
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      // limit_scope=each gives every result type its own limit, so suggestions and articles never crowd out products.
      var url = (routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(term) +
        '&resources%5Btype%5D=query,collection,product,article&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          var found = (data && data.resources && data.resources.results) || {};
          if (input.value.trim() === term) render(term, found.products || [], found.queries || [], found.collections || [], found.articles || []);
        })
        .catch(function (err) { if (err && err.name !== 'AbortError') close(); });
    }, 220);

    input.addEventListener('input', search);
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && results.innerHTML) { results.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
    input.addEventListener('keydown', function (event) {
      var opts = options();
      if (results.hidden || !opts.length) return;
      if (event.key === 'ArrowDown') { event.preventDefault(); highlight((activeIndex + 1) % opts.length); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); highlight(activeIndex <= 0 ? opts.length - 1 : activeIndex - 1); }
      else if (event.key === 'Enter' && activeIndex > -1) { event.preventDefault(); window.location.href = opts[activeIndex].href; }
      else if (event.key === 'Escape') { event.stopPropagation(); close(); }
    });
    form.addEventListener('focusout', function () {
      setTimeout(function () { if (!form.contains(document.activeElement)) close(); }, 120);
    });
  });

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var min = input.min !== '' ? parseInt(input.min, 10) : 0;
    var value = parseInt(input.value, 10) || 0;
    value = btn.hasAttribute('data-qty-plus') ? value + 1 : Math.max(min, value - 1);
    if (String(value) === input.value) return;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Newsletter link in the announcement bar ---------- */
  // Scrolls to the signup at the bottom of the page and puts the cursor in the email field.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-newsletter-link]');
    if (!link) return;
    var signup = $('[data-newsletter]');
    if (!signup) return;
    event.preventDefault();
    signup.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var field = $('input[type="email"]', signup);
    if (field) setTimeout(function () { field.focus({ preventScroll: true }); }, 450);
  });

  /* ---------- Cart count and notice ---------- */
  function updateCartCount(count, quiet) {
    $$('.header__icon--cart').forEach(function (link) {
      var badge = $('.cart-count', link);
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          badge.setAttribute('aria-hidden', 'true');
          link.appendChild(badge);
        }
        var changed = badge.textContent !== String(count);
        badge.textContent = count;
        if (!quiet && changed) {
          badge.classList.remove('is-bumped');
          void badge.offsetWidth;
          badge.classList.add('is-bumped');
        }
      } else if (badge) {
        badge.remove();
      }
      link.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  var notice = null;
  var noticeTimer = null;
  function getNotice() {
    if (notice) return notice;
    notice = document.createElement('div');
    notice.className = 'cart-notice';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.innerHTML =
      '<div class="cart-notice__head"><p class="cart-notice__title"></p>' +
      '<button type="button" class="cart-notice__close" aria-label="Close">' + ICONS.close + '</button></div>' +
      '<div class="cart-notice__body"></div>';
    document.body.appendChild(notice);
    $('.cart-notice__close', notice).addEventListener('click', hideNotice);
    notice.addEventListener('mouseenter', function () { clearTimeout(noticeTimer); });
    notice.addEventListener('mouseleave', function () { noticeTimer = setTimeout(hideNotice, 3000); });
    return notice;
  }

  function shippingProgressHtml(total) {
    var ship = theme.freeShipping || {};
    if (!ship.enabled || !ship.threshold || typeof total !== 'number') return '';
    var remaining = ship.threshold - total;
    var percent = Math.max(0, Math.min(100, Math.round((total / ship.threshold) * 100)));
    var text = remaining > 0
      ? 'You are <strong>' + escapeHtml(formatMoney(remaining)) + '</strong> away from free shipping.'
      : 'Your order ships free.';
    return '<div class="cart-notice__ship' + (remaining > 0 ? '' : ' is-done') + '">' +
      '<p>' + ICONS.truck + '<span>' + text + '</span></p>' +
      '<span class="cart-notice__bar" aria-hidden="true"><span style="width:' + percent + '%"></span></span>' +
      '</div>';
  }

  function showNotice(item, cart, errorMessage) {
    var count = cart ? cart.item_count : 0;
    var el = getNotice();
    var title = $('.cart-notice__title', el);
    var body = $('.cart-notice__body', el);
    el.classList.toggle('cart-notice--error', !!errorMessage);
    if (errorMessage) {
      title.innerHTML = ICONS.alert + '<span>We could not add that</span>';
      body.innerHTML = '<p class="cart-notice__variant">' + escapeHtml(errorMessage) + '</p>';
    } else {
      var image = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      title.innerHTML = ICONS.check + '<span>Added to your cart</span>';
      body.innerHTML =
        '<div class="cart-notice__product">' +
        '<div class="cart-notice__media">' + (image ? '<img src="' + escapeHtml(image) + '" alt="" width="60" height="60">' : '') + '</div>' +
        '<div><p class="cart-notice__name">' + escapeHtml(item.product_title) + '</p>' +
        (variant ? '<p class="cart-notice__variant">' + escapeHtml(variant) + '</p>' : '') +
        '<p class="cart-notice__variant">Quantity ' + escapeHtml(item.quantity) + '</p></div></div>' +
        (cart ? shippingProgressHtml(cart.total_price) : '') +
        '<div class="cart-notice__actions">' +
        '<a href="' + escapeHtml(routes.cart || '/cart') + '" class="button button--outline button--small">View cart (' + count + ')</a>' +
        '<a href="' + escapeHtml(ROOT + '/checkout') + '" class="button button--small">Check out</a>' +
        '</div>';
    }
    clearTimeout(noticeTimer);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    noticeTimer = setTimeout(hideNotice, errorMessage ? 6000 : 5000);
  }

  function hideNotice() {
    if (notice) notice.classList.remove('is-visible');
  }

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!window.fetch || !window.FormData) return;
    event.preventDefault();
    var button = event.submitter || $('[type="submit"]', form);
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
    var addUrl = (routes.cartAdd || '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          showNotice(null, null, res.data.description || res.data.message || 'Please try again.');
          return null;
        }
        var item = res.data.items ? res.data.items[0] : res.data;
        return fetch((routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            showNotice(item, cart);
            // On the cart page, show the new line and totals right away.
            $$('[data-cart]').forEach(function (cartEl) { refreshCart(cartEl); });
          });
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); }
      });
  });

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var jsonEl = $('[data-product-json]', section);
    var product = null;
    try { product = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (e) { product = null; }
    if (product && product.handle) rvAdd(product.handle);

    /* Gallery */
    var slides = $$('.product__slide', section);
    var thumbs = $$('[data-thumb]', section);
    function showMedia(id) {
      id = String(id);
      var found = false;
      slides.forEach(function (slide) {
        var match = slide.getAttribute('data-media-id') === id;
        slide.classList.toggle('is-active', match);
        if (match) found = true;
      });
      if (!found) return;
      thumbs.forEach(function (thumb) {
        var match = thumb.getAttribute('data-thumb') === id;
        thumb.classList.toggle('is-active', match);
        if (match) { thumb.setAttribute('aria-current', 'true'); } else { thumb.removeAttribute('aria-current'); }
      });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.getAttribute('data-thumb')); });
    });

    /* Image viewer: gallery images and images inside the description */
    var zoomSlides = slides.filter(function (s) { return s.hasAttribute('data-zoom'); });
    function openGalleryZoom() {
      if (!zoomSlides.length) return;
      var active = slides.find(function (s) { return s.classList.contains('is-active'); });
      var start = Math.max(0, zoomSlides.indexOf(active));
      lightbox.open(zoomSlides.map(function (s) {
        return { src: s.getAttribute('data-zoom'), alt: s.getAttribute('data-zoom-alt') || '' };
      }), start);
    }
    $$('[data-zoom-open]', section).forEach(function (btn) { btn.addEventListener('click', openGalleryZoom); });
    zoomSlides.forEach(function (s) {
      var image = $('img', s);
      if (image) image.addEventListener('click', openGalleryZoom);
    });
    $$('.product__description img, .product__text img, .accordion__content img', section).forEach(function (image) {
      if (image.closest('a')) return;
      image.classList.add('is-zoomable');
      image.setAttribute('tabindex', '0');
      image.setAttribute('role', 'button');
      image.setAttribute('aria-label', 'View larger: ' + (image.alt || 'image'));
      var openOne = function () { lightbox.open([{ src: image.currentSrc || image.src, alt: image.alt || '' }], 0); };
      image.addEventListener('click', openOne);
      image.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openOne(); }
      });
    });

    /* Add to cart bar that follows the shopper down the page */
    var sticky = $('[data-sticky-cart]', section);
    var buyBox = $('.product__buy', section);
    var stickyForm = document.getElementById(section.getAttribute('data-form-id'));
    if (sticky && buyBox && stickyForm && 'IntersectionObserver' in window) {
      var stickyButton = $('[data-sticky-add]', sticky);
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        if (stickyButton) stickyButton.tabIndex = past ? 0 : -1;
        document.body.classList.toggle('has-sticky-cart', past);
      }).observe(buyBox);
    } else if (sticky) {
      sticky.remove();
      sticky = null;
    }

    var stage = $('.product__stage', section);
    if (stage && slides.length > 1) {
      var startX = null;
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        var current = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        var next = (current + (dx < 0 ? 1 : -1) + slides.length) % slides.length;
        showMedia(slides[next].getAttribute('data-media-id'));
      });
    }

    /* Variants */
    var picker = $('[data-variant-picker]', section);
    if (!product || !picker) return;
    var variants = product.variants || [];
    var inputs = $$('input[data-option-index]', picker);
    var idInput = $('[data-variant-input]', section);
    var addButton = $('[data-add-button]', section);
    var addLabel = $('[data-add-label]', section);
    var priceWrap = $('.product__price [data-price]', section);
    var availability = $('[data-availability]', section);

    function selectedOptions() {
      var selected = [];
      inputs.forEach(function (input) {
        if (input.checked) selected[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return selected.every(function (value, i) { return v.options[i] === value; });
      });
    }

    function markAvailability(selected) {
      inputs.forEach(function (input) {
        var index = parseInt(input.getAttribute('data-option-index'), 10);
        var test = selected.slice();
        test[index] = input.value;
        var available = variants.some(function (v) {
          return v.available && test.every(function (value, i) { return value === undefined || v.options[i] === value; });
        });
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !available);
      });
    }

    function update() {
      var selected = selectedOptions();
      selected.forEach(function (value, i) {
        var out = $('[data-option-value="' + i + '"]', picker);
        if (out) out.textContent = value;
      });
      markAvailability(selected);
      var variant = findVariant(selected);

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (sticky) {
          var unavailableBtn = $('[data-sticky-add]', sticky);
          var unavailableLabel = $('[data-sticky-label]', sticky);
          if (unavailableBtn) unavailableBtn.disabled = true;
          if (unavailableLabel) unavailableLabel.textContent = 'Unavailable';
        }
        if (availability) availability.innerHTML = '<span class="dot dot--out"></span>This combination is not available';
        return;
      }

      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (priceWrap) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var current = $('[data-price-current]', priceWrap);
        var compare = $('[data-price-compare]', priceWrap);
        var compareLabel = $('[data-price-compare-label]', priceWrap);
        var label = $('[data-price-label]', priceWrap);
        if (current) current.textContent = formatMoney(variant.price);
        if (compare) { compare.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; compare.hidden = !onSale; }
        if (compareLabel) compareLabel.hidden = !onSale;
        if (label) label.textContent = onSale ? 'Sale price' : 'Price';
        var save = $('[data-price-save]', priceWrap);
        if (save) {
          save.hidden = !onSale;
          save.textContent = onSale ? 'Save ' + formatMoney(variant.compare_at_price - variant.price) : '';
        }
        priceWrap.classList.toggle('price--sale', !!onSale);
      }

      if (sticky) {
        var stickyPrice = $('[data-sticky-price]', sticky);
        var stickyVariant = $('[data-sticky-variant]', sticky);
        var stickyAdd = $('[data-sticky-add]', sticky);
        var stickyLabel = $('[data-sticky-label]', sticky);
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        if (stickyVariant) stickyVariant.textContent = variant.title;
        if (stickyAdd) stickyAdd.disabled = !variant.available;
        if (stickyLabel) stickyLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      if (availability) {
        availability.innerHTML = variant.available
          ? '<span class="dot dot--in"></span>In stock, ready to ship'
          : '<span class="dot dot--out"></span>Sold out <a href="#related-products" class="link product__similar">See similar products</a>';
      }
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

      if (variant.featured_media && variant.featured_media.id) showMedia(variant.featured_media.id);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', update);
    markAvailability(selectedOptions());
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (section) {
    var url = section.getAttribute('data-url');
    if (!url || section.querySelector('.grid')) return;
    var loaded = false;
    var load = function () {
      if (loaded) return;
      loaded = true;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.querySelector('.grid')) section.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(section);
      // Safety net: load anyway once the page has settled, so the row never stays missing.
      window.addEventListener('load', function () { setTimeout(function () { io.disconnect(); load(); }, 2500); });
    } else {
      load();
    }
  });

  /* ---------- Collection filters and sorting ---------- */
  function closeFilters() {
    $$('[data-filters].is-open').forEach(function (wrap) {
      wrap.classList.remove('is-open');
      var toggle = $('[data-filters-toggle]', wrap);
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      lockScroll(false);
    });
  }

  function submitFilters(form) {
    var data = new FormData(form);
    var params = new URLSearchParams();
    data.forEach(function (value, key) {
      if (value === '' || value == null) return;
      params.append(key, value);
    });
    var action = form.getAttribute('action') || window.location.pathname;
    var query = params.toString();
    window.location.href = action + (query ? '?' + query : '');
  }

  $$('[data-filters]').forEach(function (wrap) {
    var toggle = $('[data-filters-toggle]', wrap);
    if (toggle) {
      toggle.addEventListener('click', function () {
        wrap.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        lockScroll(true);
        var close = $('.filters__close', wrap);
        if (close) setTimeout(function () { close.focus(); }, 60);
      });
    }
    $$('[data-filters-close]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeFilters();
        if (toggle) toggle.focus();
      });
    });
    $$('[data-filters-more]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.filters__group');
        if (group) group.classList.add('is-expanded');
      });
    });
  });

  $$('[data-filter-form]').forEach(function (form) {
    var debouncedSubmit = debounce(function () { submitFilters(form); }, 650);
    form.addEventListener('change', function (event) {
      if (!desktop.matches) return;
      if (event.target.type === 'number') { debouncedSubmit(); } else { submitFilters(form); }
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitFilters(form);
    });
  });

  $$('select[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.form;
      if (!form) return;
      if (form.hasAttribute('data-filter-form')) { submitFilters(form); } else { form.submit(); }
    });
  });

  /* ---------- Cart page ---------- */
  function cartSectionId(el) {
    var wrap = el.closest('.shopify-section');
    return wrap ? wrap.id.replace(/^shopify-section-/, '') : null;
  }

  function refreshCart(cartEl) {
    var id = cartSectionId(cartEl);
    if (!id) { window.location.reload(); return Promise.resolve(); }
    return fetch((routes.cart || '/cart') + '?section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-cart]');
        if (fresh) { cartEl.innerHTML = fresh.innerHTML; applyContinueLinks(cartEl); bindCartBar(cartEl); } else { window.location.reload(); }
      });
  }

  // Phones: show a Check out bar whenever the order summary's own button is off screen.
  function bindCartBar(cartEl) {
    if (cartEl._barObserver) { cartEl._barObserver.disconnect(); cartEl._barObserver = null; }
    var bar = $('[data-cart-bar]', cartEl);
    var target = $('.cart__summary [name="checkout"]', cartEl);
    if (!bar) { document.body.classList.remove('has-sticky-cart'); return; }
    if (!target || !('IntersectionObserver' in window)) { bar.remove(); return; }
    var button = $('[data-cart-bar-button]', bar);
    var observer = new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting && window.matchMedia('(max-width: 749px)').matches;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (button) button.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('has-sticky-cart', show);
    });
    observer.observe(target);
    cartEl._barObserver = observer;
  }

  function sendCartUpdates(cartEl) {
    var form = $('[data-cart-form]', cartEl);
    if (!form) return;
    var qtyInputs = $$('[data-cart-qty]', form);
    var updates = qtyInputs.map(function (input) { return Math.max(0, parseInt(input.value, 10) || 0); });
    $$('.line', form).forEach(function (line) { line.classList.add('is-updating'); });
    fetch((routes.cartUpdate || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshCart(cartEl);
      })
      .catch(function () {
        var updateBtn = $('[data-cart-update]', form);
        if (form.requestSubmit && updateBtn) { form.requestSubmit(updateBtn); } else { form.submit(); }
      });
  }

  $$('[data-cart]').forEach(function (cartEl) {
    bindCartBar(cartEl);
    var debounced = debounce(function () { sendCartUpdates(cartEl); }, 450);
    cartEl.addEventListener('change', function (event) {
      if (event.target.matches('[data-cart-qty]')) debounced();
    });
    cartEl.addEventListener('click', function (event) {
      var remove = event.target.closest('.line__remove');
      if (!remove) return;
      var line = remove.closest('.line');
      var input = line && $('[data-cart-qty]', line);
      if (!input) return;
      event.preventDefault();
      input.value = 0;
      sendCartUpdates(cartEl);
    });
  });

  /* ---------- Recently viewed ---------- */
  function fetchCard(handle) {
    var cache = storageGet('sessionStorage', RV_CACHE) || {};
    var hit = cache[handle];
    if (hit && hit.html && Date.now() - hit.t < 10 * 60 * 1000) return Promise.resolve(hit.html);
    return fetch(ROOT + '/products/' + encodeURIComponent(handle) + '?section_id=api-product-card')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var card = doc.querySelector('[data-api-card] .card');
        if (!card) throw new Error('missing card');
        var fresh = storageGet('sessionStorage', RV_CACHE) || {};
        fresh[handle] = { t: Date.now(), html: card.outerHTML };
        storageSet('sessionStorage', RV_CACHE, fresh);
        return card.outerHTML;
      });
  }

  $$('[data-recently-viewed]').forEach(function (section) {
    var list = $('[data-recently-list]', section);
    if (!list || !window.fetch || !window.DOMParser) return;
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
    // Skip the product being viewed, or on the cart page the products already in the cart.
    var exclude = (section.getAttribute('data-exclude') || '').split(',').filter(Boolean);
    var handles = rvRead().filter(function (h) { return exclude.indexOf(h) < 0; }).slice(0, limit + 2);
    if (!handles.length) return;

    Promise.all(handles.map(function (h) {
      return fetchCard(h).catch(function () { rvRemove(h); return ''; });
    })).then(function (cards) {
      var html = cards.filter(Boolean).slice(0, limit).map(function (card) {
        return '<li class="grid__item">' + card + '</li>';
      }).join('');
      if (!html) return;
      list.innerHTML = html;
      section.hidden = false;
    });

    var clear = $('[data-recently-clear]', section);
    if (clear) {
      clear.addEventListener('click', function () {
        rvClear();
        list.innerHTML = '';
        section.hidden = true;
      });
    }
  });

  /* ---------- Blog sidebar: products matched to the post ---------- */
  var TOPIC_STOP_WORDS = ('a an the of to in on at for and or with your you our is are be do does should can how what why when ' +
    'which look guide benefits benefit explained its it about vs versus connection').split(' ');

  function topicsFromTitle(title) {
    var head = String(title || '').replace(/[\u2018\u2019]/g, "'").split(/[:?|\u2013\u2014]/)[0];
    return head.split(/,|\s&\s|\sand\s/i).map(function (part) {
      return part.replace(/[^\w\s'-]/g, ' ').split(/\s+/).filter(function (word) {
        return word && TOPIC_STOP_WORDS.indexOf(word.toLowerCase()) < 0;
      }).slice(0, 3).join(' ');
    }).filter(function (topic) { return topic.length >= 4; }).slice(0, 3);
  }

  function searchProducts(term, limit) {
    var url = (routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(term) +
      '&resources%5Btype%5D=product&resources%5Blimit%5D=' + limit + '&resources%5Boptions%5D%5Bunavailable_products%5D=hide';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        return (data && data.resources && data.resources.results && data.resources.results.products) || [];
      })
      .catch(function () { return []; });
  }

  // Words that must all appear in a product's title, tags or description for it to count as a match.
  function keyWords(topic) {
    return topic.toLowerCase().split(/\s+/).map(function (word) {
      return word.replace(/'s$/, '').replace(/[^a-z0-9-]/g, '');
    }).filter(function (word) { return word.length >= 4; });
  }

  function isRelevant(product, words) {
    var hay = (product.title + ' ' + (product.tags || []).join(' ') + ' ' + String(product.body || '').replace(/<[^>]+>/g, ' ')).toLowerCase();
    return words.every(function (word) { return hay.indexOf(word) > -1; });
  }

  function topicMatches(topic, limit) {
    var fetchCount = Math.max(limit, 6);
    return searchProducts(topic, fetchCount).then(function (products) {
      var strict = products.filter(function (p) { return isRelevant(p, keyWords(topic)); });
      var words = topic.split(' ');
      var last = words[words.length - 1];
      if (strict.length || words.length < 2 || last.length < 4) return strict;
      return searchProducts(last, fetchCount).then(function (more) {
        return more.filter(function (p) { return isRelevant(p, keyWords(last)); });
      });
    }).then(function (products) {
      return products.map(function (p) { return p.handle; });
    });
  }

  function fetchMini(handle) {
    return fetch(ROOT + '/products/' + encodeURIComponent(handle) + '?section_id=api-product-mini')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (text) {
        var row = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-api-mini] .mini-product');
        return row ? row.outerHTML : '';
      })
      .catch(function () { return ''; });
  }

  $$('[data-shop-the-post]').forEach(function (block) {
    if (block.getAttribute('data-match') !== 'true') return;
    var list = $('[data-shop-list]', block);
    var title = $('[data-shop-title]', block);
    var limit = parseInt(block.getAttribute('data-limit'), 10) || 3;
    var finish = function () { block.classList.remove('is-matching'); };
    var safety = setTimeout(finish, 4000);
    if (!list || !window.fetch || !window.DOMParser) { clearTimeout(safety); finish(); return; }

    var tags = (block.getAttribute('data-topics') || '').split('|').map(function (t) { return t.trim(); }).filter(Boolean);
    var topics = tags.length ? tags.slice(0, 3) : topicsFromTitle(block.getAttribute('data-title'));
    if (!topics.length) { clearTimeout(safety); finish(); return; }

    Promise.all(topics.map(function (topic) { return topicMatches(topic, limit); }))
      .then(function (groups) {
        // Take results in turn from each topic so a post about several ingredients shows each of them.
        var handles = [];
        for (var round = 0; round < limit && handles.length < limit; round++) {
          groups.forEach(function (group) {
            var handle = group[round];
            if (handle && handles.length < limit && handles.indexOf(handle) < 0) handles.push(handle);
          });
        }
        if (!handles.length) return null;
        return Promise.all(handles.map(fetchMini));
      })
      .then(function (rows) {
        rows = (rows || []).filter(Boolean);
        if (rows.length) {
          list.innerHTML = rows.map(function (row) { return '<li>' + row + '</li>'; }).join('');
          if (title) title.textContent = block.getAttribute('data-topic-heading') || title.textContent;
        }
      })
      .then(function () { clearTimeout(safety); finish(); }, function () { clearTimeout(safety); finish(); });
  });

  /* ---------- Copy link ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-copy-link]');
    if (!btn) return;
    var url = btn.getAttribute('data-copy-link');
    var label = $('[data-copy-label]', btn);
    var done = function () {
      if (!label) return;
      label.textContent = 'Link copied';
      setTimeout(function () { label.textContent = 'Copy link'; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); });
    } else {
      window.prompt('Copy this link', url);
    }
  });

  /* ---------- Navigation helpers ---------- */
  // Remember the last list the shopper browsed so Continue shopping can take them back to it.
  var CONTINUE_KEY = 'ov:continue-shopping';
  if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {
    storageSet('sessionStorage', CONTINUE_KEY, window.location.pathname + window.location.search);
  }
  function applyContinueLinks(scope) {
    var target = storageGet('sessionStorage', CONTINUE_KEY);
    if (typeof target !== 'string' || target.charAt(0) !== '/' || target.charAt(1) === '/') return;
    $$('[data-continue-shopping]', scope).forEach(function (link) { link.setAttribute('href', target); });
  }
  applyContinueLinks();

  // Product links use each product's own address, so the product page breadcrumb names its main
  // category. When the shopper arrives from a collection or from search results, the breadcrumb
  // leads back to that list instead.
  var LAST_LIST_KEY = 'ov:last-collection';
  var collectionSection = $('[data-collection-title]');
  if (collectionSection) {
    storageSet('sessionStorage', LAST_LIST_KEY, { path: window.location.pathname, title: collectionSection.getAttribute('data-collection-title') });
  }
  (function () {
    var crumbs = $('[data-product-breadcrumbs] ol');
    if (!crumbs || !document.referrer) return;
    var ref;
    try { ref = new URL(document.referrer); } catch (e) { return; }
    if (ref.origin !== window.location.origin) return;
    var label = null;
    if (/\/search$/.test(ref.pathname)) {
      label = 'Search results';
    } else {
      var last = storageGet('sessionStorage', LAST_LIST_KEY);
      if (last && last.path === ref.pathname && typeof last.title === 'string' && last.title) label = last.title;
    }
    if (!label) return;
    var crumb = $('[data-crumb-parent]', crumbs);
    if (!crumb) {
      crumb = document.createElement('li');
      crumb.setAttribute('data-crumb-parent', '');
      crumbs.insertBefore(crumb, crumbs.lastElementChild);
    }
    crumb.innerHTML = '<a href="' + escapeHtml(ref.pathname + ref.search) + '">' + escapeHtml(label) + '</a>';
  })();

  // Pages restored by the browser's back button can show an old cart; refresh it.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || !window.fetch) return;
    fetch((routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count, true);
        $$('[data-cart]').forEach(function (cartEl) { refreshCart(cartEl); });
      })
      .catch(function () {});
  });

  // Back to top
  var backToTop = $('[data-back-to-top]');
  if (backToTop) {
    var backTicking = false;
    var syncBackToTop = function () {
      backTicking = false;
      var show = window.scrollY > window.innerHeight * 1.5;
      backToTop.classList.toggle('is-visible', show);
      backToTop.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', function () {
      if (!backTicking) { backTicking = true; requestAnimationFrame(syncBackToTop); }
    }, { passive: true });
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      var main = $('#MainContent');
      if (main) main.focus({ preventScroll: true });
    });
    syncBackToTop();
  }

  // Keep keyboard focus inside the phone menu and filter panel while they are open.
  function trapFocus(container, event) {
    if (event.key !== 'Tab') return;
    var focusables = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea, summary, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
  if (drawer) {
    var drawerPanel = $('.drawer', drawer);
    if (drawerPanel) drawerPanel.addEventListener('keydown', function (event) { if (drawer.open) trapFocus(drawerPanel, event); });
  }
  $$('[data-filters]').forEach(function (wrap) {
    var panel = $('[data-filters-panel]', wrap);
    if (panel) panel.addEventListener('keydown', function (event) { if (wrap.classList.contains('is-open')) trapFocus(panel, event); });
  });

  /* ---------- Document pages: section links, numbered headings, subheadings ---------- */
  function slugify(text) {
    return String(text).toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }
  $$('[data-doc]').forEach(function (doc) {
    // Shopify repeats the policy name above the policy text; the page header already shows it,
    // so the page keeps a single main heading
    $$('.shopify-policy__title', doc).forEach(function (title) { title.remove(); });
    var prose = $$('.rte', doc);
    if (!prose.length) return;
    var headings = [];
    // Line breaks pasted at the start or end of a paragraph only add empty lines
    function trimBreaks(el, fromStart) {
      var node = fromStart ? el.firstChild : el.lastChild;
      while (node) {
        var next = fromStart ? node.nextSibling : node.previousSibling;
        if (node.nodeType === 3 && !node.nodeValue.trim()) { node = next; continue; }
        if (node.nodeType === 1 && node.tagName === 'BR') { el.removeChild(node); node = next; continue; }
        if (node.nodeType === 1 && /^(SPAN|STRONG|B|EM|I)$/.test(node.tagName)) trimBreaks(node, fromStart);
        break;
      }
    }
    prose.forEach(function (rte) {
      $$('p', rte).forEach(function (p) {
        trimBreaks(p, true);
        trimBreaks(p, false);
        if (!p.textContent.replace(/ /g, ' ').trim() && !p.querySelector('img, iframe, video, svg, input, button')) p.hidden = true;
      });
      // A short bold line on its own reads as a subheading
      $$('p', rte).forEach(function (p) {
        var only = p.children.length === 1 ? p.children[0] : null;
        if (!only || !/^(STRONG|B|SPAN)$/.test(only.tagName)) return;
        var text = p.textContent.replace(/\s+/g, ' ').trim();
        if (!text || text !== only.textContent.replace(/\s+/g, ' ').trim()) return;
        if (text.length > 60 || /[.!?]$/.test(text)) return;
        p.classList.add('doc__subhead');
      });
      $$('h2', rte).forEach(function (h) { headings.push(h); });
    });
    var used = {};
    headings.forEach(function (h) {
      var first = h.firstChild;
      if (first && first.nodeType === 3) {
        var match = first.nodeValue.match(/^\s*(\d+(?:\.\d+)*\.?)\s+(?=\S)/);
        if (match) {
          var num = document.createElement('span');
          num.className = 'doc__num';
          num.textContent = match[1];
          first.nodeValue = ' ' + first.nodeValue.slice(match[0].length);
          h.insertBefore(num, first);
        }
      }
      if (!h.id) {
        var base = slugify(h.textContent) || 'section';
        var id = base;
        var n = 2;
        while (used[id] || document.getElementById(id)) id = base + '-' + n++;
        h.id = id;
      }
      used[h.id] = true;
    });
    if (headings.length < 4) return;
    // Section links: open on wider screens, folded on phones so the text starts sooner
    var wide = window.matchMedia('(min-width: 750px)');
    var toc = document.createElement('nav');
    toc.className = 'doc-toc';
    toc.setAttribute('aria-label', 'On this page');
    var html = '<details class="doc-toc__details"' + (wide.matches ? ' open' : '') + '>' +
      '<summary class="doc-toc__title"><span>On this page</span>' +
      '<svg class="icon icon-chevron" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M7 10l5 5 5-5"/></svg>' +
      '</summary><ol class="doc-toc__list" role="list">';
    headings.forEach(function (h) {
      html += '<li><a href="#' + h.id + '">' + escapeHtml(h.textContent.replace(/\s+/g, ' ').trim()) + '</a></li>';
    });
    toc.innerHTML = html + '</ol></details>';
    doc.insertBefore(toc, doc.firstChild);
    var details = $('details', toc);
    $('summary', toc).addEventListener('click', function (event) { if (wide.matches) event.preventDefault(); });
    wide.addEventListener('change', function () { if (wide.matches) details.open = true; });
  });

  /* ---------- Customer addresses ---------- */
  $$('[data-address-country]').forEach(function (row) {
    var country = $('[data-country-select]', row);
    var province = $('[data-province-select]', row);
    var provinceWrap = $('[data-province-wrap]', row);
    if (!country || !province) return;

    var defaultCountry = country.getAttribute('data-default');
    if (defaultCountry) {
      $$('option', country).forEach(function (opt) { if (opt.value === defaultCountry) opt.selected = true; });
    }

    function fillProvinces(initial) {
      var option = country.options[country.selectedIndex];
      var list = [];
      try { list = JSON.parse((option && option.getAttribute('data-provinces')) || '[]'); } catch (e) { list = []; }
      province.innerHTML = '';
      if (!list.length) { if (provinceWrap) provinceWrap.hidden = true; return; }
      if (provinceWrap) provinceWrap.hidden = false;
      var wanted = initial ? province.getAttribute('data-default') : '';
      list.forEach(function (pair) {
        var opt = document.createElement('option');
        opt.value = pair[0];
        opt.textContent = pair[1];
        if (pair[0] === wanted) opt.selected = true;
        province.appendChild(opt);
      });
    }
    fillProvinces(true);
    country.addEventListener('change', function () { fillProvinces(false); });
  });

  $$('form[data-confirm]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!window.confirm(form.getAttribute('data-confirm'))) event.preventDefault();
    });
  });
})();
